import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SeDropdownItem.scss';

export default class SeDropdownItem extends Component {
    handleItemClick = () => {
        this.props.onSelect(this.props.value);
    };

    render() {
        const { children, selected } = this.props;
        const itemClass = classNames({
            [styles.item]: true,
            [styles.itemSelected]: selected,
        });
        const dataAttributes = selected
            ? {
                  'data-selected': true,
              }
            : {};
        return (
            <li className={itemClass} onClick={this.handleItemClick} {...dataAttributes}>
                {children}
            </li>
        );
    }
}

SeDropdownItem.propTypes = {
    value: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.bool,
};

SeDropdownItem.defaultProps = {
    selected: false,
};
